<template>
  <div class="contents" v-loading="loading">
    <div class="title flexB">
      <h2>단어 관리</h2>
    </div>

    <ul class="categories flexL box" v-if="categories.length > 0">
      <li
        :class="{ unselect: true, active: category === '' }"
        @click="handleCategory('')"
      >
        전체 ({{ categoryTotal }})
      </li>
      <li
        :class="{ unselect: true, active: cat.name === category }"
        @click="handleCategory(cat.name)"
        v-for="(cat, i) in categories"
        :key="i"
      >
        {{ getCategoryDisplayName(cat.name) }} ({{ cat.count }})
      </li>
    </ul>
    <div class="box one">
      <div class="flexB mb20">
        <div class="flex searchWrap">
          <input
            type="text"
            v-model="searchWord"
            placeholder="Search"
            @keyup.enter="search"
          />

          <button @click="search" class="searchIcon">
            <img src="@/assets/images/icon_svg/search.svg" alt="search" />
          </button>
          <button class="cancel line" @click="reset">Cancel</button>
        </div>

        <div class="flex">
          <div class="filebox">
            <label for="fileUpload" class="basic w100 unselect">대량등록</label>
            <input
              id="fileUpload"
              type="file"
              @change="handleFileUpload"
              accept=".xlsx, .xls"
            />
          </div>
          <a
            class="line2 sample-link"
            :href="wordBulkSampleHref"
            download="word-bulk-sample.xlsx"
            >샘플 양식 다운로드</a
          >
          <button
            class="line2 sample-link"
            type="button"
            @click="downloadWordData"
          >
            데이터 다운로드
          </button>
          <router-link
            class="line2"
            :to="
              category
                ? { path: '/admin/word/register', query: { category } }
                : '/admin/word/register'
            "
            >단어 등록</router-link
          >
        </div>
      </div>

      <table>
        <colgroup>
          <col style="width: 5%" />
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 16%" />
          <col style="width: 16%" />
          <col style="width: 8%" />
          <col style="width: 24%" />
          <col style="width: 20%" />
        </colgroup>
        <tr>
          <th>
            <el-checkbox
              v-model="checkAll"
              @change="handleCheckAllChange"
            ></el-checkbox>
            <button @click="deleteWords" class="delete" v-if="ids.length > 0">
              삭제
            </button>
          </th>
          <th>번호</th>
          <th>카테고리</th>
          <th>한글단어</th>
          <th>영어단어</th>
          <th>품사</th>
          <th>예문</th>
          <th>등록일</th>
        </tr>
        <tr v-for="(data, i) in wordList" :key="i">
          <td>
            <el-checkbox
              v-model="ids"
              :label="data._id"
              class="no-label-checkbox"
              @change="handleIdsChange"
            ></el-checkbox>
          </td>
          <td>
            {{ total - ((currentPage - 1) * 20 + i) }}
          </td>
          <td>{{ data.category }}</td>
          <td>
            <router-link to @click.native="handleMove(data._id)">{{
              data.word
            }}</router-link>
          </td>
          <td>{{ data.word_en }}</td>
          <td>{{ data.parts }}</td>
          <td>{{ data.description[0]?.desc_kr }}</td>
          <td>
            {{ moment(data.createdAt).format("YYYY.MM.DD HH:mm") }}
          </td>
        </tr>
      </table>
      <div class="pagination" v-if="wordList.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="20"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <NoData v-else />
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";

import moment from "moment";
import {
  fetchWordList,
  fetchWordCategories,
  createWordBulk,
  removeWordAll,
} from "@/api/admin";
import { format } from "@/mixins/format";
import NoData from "@/components/contents/Nodata";
import category from "@/config/wordCategory.json";
import { getWordCategoryDisplayName } from "@/utils/wordCategoryDisplay";

const WORD_BULK_HEADERS = [
  "카테고리",
  "품사",
  "한글단어",
  "발음",
  "영어",
  "일본어",
  "예문(한국어)",
  "예문(영어)",
  "예문(일본어)",
];

export default {
  mixins: [format],
  components: { NoData },
  name: "wordManage",
  data() {
    return {
      moment: moment,
      loading: false,
      inputMode: "word",
      searchWord: "",
      wordList: [],
      total: 0,
      currentPage: 1,
      isNodata: false,
      category: "",
      categories: [],
      categoryTotal: 0,
      isUpload: false,
      ids: [],
      checkAll: false,
    };
  },
  computed: {
    wordBulkSampleHref() {
      const base = process.env.BASE_URL || "/";
      return `${base.replace(/\/?$/, "/")}word-bulk-sample.xlsx`;
    },
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "2");
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === "wordRegister" && from.query.page) {
        vm.currentPage = parseInt(from.query.page);
      } else if (to.query.page) {
        vm.currentPage = parseInt(to.query.page);
      } else {
        vm.currentPage = 1;
      }

      if (from.name === "wordRegister" && from.query.category) {
        vm.category = from.query.category;
      } else if (to.query.category) {
        vm.category = to.query.category;
      } else {
        vm.category = "";
      }

      const currentQueryPage = to.query.page;
      const currentQueryCategory = to.query.category;
      const newPage = String(vm.currentPage);
      const newCategory = vm.category;

      const shouldReplace =
        currentQueryPage !== newPage ||
        (currentQueryCategory || "") !== newCategory;

      if (shouldReplace) {
        const query = { page: newPage };
        if (newCategory) query.category = newCategory;

        vm.$router.replace({
          name: "wordManage",
          query,
        });
      }

      vm.getWordList();
    });
  },

  mounted() {
    this.loading = true;
    this.getCategories();
  },
  methods: {
    getCategoryDisplayName(name) {
      return getWordCategoryDisplayName(name);
    },
    deleteWords() {
      let result = confirm("삭제 하시겠습니까?");
      if (!result) {
        return;
      }
      let data = {
        ids: this.ids,
      };
      removeWordAll(data).then((res) => {
        if (res.data.status == 200) {
          alert("삭제 되었습니다.");
          this.reset();
          this.checkAll = false;
          this.ids = [];
        }
      });
    },
    handleCheckAllChange(val) {
      this.ids = val ? this.wordList.map((item) => item._id) : [];
    },
    handleIdsChange() {
      this.checkAll = this.ids.length == this.wordList.length;
    },
    getCategories() {
      fetchWordCategories().then((res) => {
        if (res.data.status == 200) {
          this.categoryTotal = res.data.totalCount;
          let categoryCounts = res.data.data;
          let tempCat = category.categories;

          this.categories = tempCat
            .map((name) => {
              const found = categoryCounts.find((c) => c._id === name);
              return {
                name: name,
                count: found ? found.count : 0,
              };
            })
            .sort((a, b) =>
              a.name.localeCompare(b.name, "ko", { numeric: true }),
            );
        } else {
          let message = res.data.message;
          alert(message);
        }
      });
    },
    handleCategory(cat) {
      this.loading = true;
      this.currentPage = 1;
      this.category = cat;
      let query = {
        page: this.currentPage,
      };
      if (this.category) {
        query.category = this.category;
      }
      this.$router.push({
        name: "wordManage",
        query: query,
      });

      this.getWordList();
    },
    buildWordExportRow(word = {}) {
      const description = Array.isArray(word.description)
        ? word.description[0] || {}
        : {};

      return [
        word.category ?? "",
        word.parts ?? "",
        word.word ?? "",
        word.pronounce ?? "",
        word.word_en ?? "",
        word.word_jp ?? "",
        description.desc_kr ?? "",
        description.desc_en ?? "",
        description.desc_jp ?? "",
      ];
    },
    async fetchAllWordsForExport() {
      const baseParams = {
        searchWord: this.searchWord,
        category: this.category,
      };
      const countRes = await fetchWordList({
        ...baseParams,
        page: 1,
        limit: 1,
      });

      if (countRes.data.status !== 200) {
        throw new Error(
          countRes.data.message || "단어 목록을 불러오지 못했습니다.",
        );
      }

      const total = Number(countRes.data.total || 0);
      if (total === 0) {
        return [];
      }

      const listRes = await fetchWordList({
        ...baseParams,
        page: 1,
        limit: total,
      });

      if (listRes.data.status !== 200) {
        throw new Error(
          listRes.data.message || "단어 목록을 불러오지 못했습니다.",
        );
      }

      return listRes.data.data || [];
    },
    async downloadWordData() {
      this.loading = true;
      try {
        const words = await this.fetchAllWordsForExport();
        if (words.length === 0) {
          return alert("다운로드할 데이터가 없습니다.");
        }

        const rows = words.map((word) => this.buildWordExportRow(word));
        const worksheet = XLSX.utils.aoa_to_sheet([WORD_BULK_HEADERS, ...rows]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "단어목록");

        const categoryLabel = this.category || "전체";
        const dateLabel = moment().format("YYYYMMDD_HHmmss");
        XLSX.writeFile(
          workbook,
          `word-data_${categoryLabel}_${dateLabel}.xlsx`,
        );
      } catch (err) {
        alert(err.message || "데이터 다운로드에 실패했습니다.");
      } finally {
        this.loading = false;
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.isUpload = true;

      const reader = new FileReader();
      reader.onload = (e) => {
        const excel = new Uint8Array(e.target.result);
        const workbook = XLSX.read(excel, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // 첫 행(헤더) 제외
        const dataRows = rows.slice(1);
        const requiredIndexes = [0, 1, 2, 3, 4, 5, 6];
        const nonEmptyRows = dataRows.filter((row) =>
          Array.isArray(row)
            ? row.some((cell) => String(cell ?? "").trim() !== "")
            : false,
        );

        const invalidRowIndex = nonEmptyRows.findIndex((row) =>
          requiredIndexes.some(
            (index) => String(row[index] ?? "").trim() === "",
          ),
        );

        if (invalidRowIndex !== -1) {
          this.isUpload = false;
          return alert(`${invalidRowIndex + 2}행: 1~7열은 필수값입니다.`);
        }

        let words = nonEmptyRows.map((row) => ({
          category: row[0] ?? "",
          parts: row[1] ?? "",
          word: row[2] ?? "",
          pronounce: row[3] ?? "",
          word_en: row[4] ?? "",
          word_jp: row[5] ?? "",
          description: [
            {
              desc_kr: row[6] ?? "",
              desc_en: row[7] ?? "",
              desc_jp: row[8] ?? "",
            },
          ],
        }));

        let data = {
          words: words,
        };
        createWordBulk(data).then((res) => {
          if (res.data.status == 200) {
            alert("단어 등록이 완료 되었습니다.");
            this.isUpload = false;
            this.reset();
          } else {
            let message = res.data.message;
            alert(message);
            this.isUpload = false;
          }
        });
      };
      reader.readAsArrayBuffer(file);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    customFormatter(date) {
      return moment(date).format("YYYY년 MM월 DD일");
    },
    handleMove(id) {
      let query = {
        id: id,
        page: this.currentPage,
      };
      if (this.category) {
        query.category = this.category;
      }
      this.$router.push({
        name: "wordRegister",
        query: query,
      });
    },

    reset() {
      // this.inputMode = "";
      this.searchWord = "";
      this.wordList = [];
      this.total = 0;
      this.currentPage = 1;
      this.category = "";
      this.handleCurrentChange(1);
    },
    search() {
      if (this.searchWord == "") {
        return alert("검색어를 입력해 주세요.");
      }
      this.getWordList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      let query = {
        page: this.currentPage,
      };
      if (this.category) {
        query.category = this.category;
      }
      this.$router.push({
        name: "wordManage",
        query: query,
      });
      this.getWordList();
    },
    getWordList() {
      let params = {
        page: this.currentPage,
        searchWord: this.searchWord,
        // inputMode: this.inputMode,
        category: this.category,
      };
      fetchWordList(params).then((res) => {
        console.log("res", res);
        if (res.data.status == 200) {
          this.wordList = res.data.data;
          this.total = res.data.total;
          this.isNodata = this.total == 0 ? true : false;
          this.loading = false;
        } else {
          let message = res.data.message;
          alert(message);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .no-label-checkbox span {
  vertical-align: middle;
  line-height: 40px;
}

::v-deep .no-label-checkbox .el-checkbox__label {
  display: none;
}
button.delete {
  width: unset;
  height: unset;
  background: unset;
  border: none;
  font-size: 12px;
  margin-bottom: 4px;
  color: #9aa7c1;
}
a.line2.sample-link,
button.line2.sample-link {
  width: auto;
  padding: 0 12px !important;
  box-sizing: border-box;
  cursor: pointer;
  font-weight: 400;
}
</style>
